import { FilterDatePicker } from "components/DatePicker/SingleDatePicker";
import AirlinePaginatedDropdown from "components/dropdowns/paginated/AirlinePaginatedDropdown";
import moment from "moment";
import React from "react";
import { Input } from "../../../components";
import RemovableAirline from "./removableairline";

interface Props {
  onSearch: (airline: server.dto.Airline, flightNumber: string, departure: moment.Moment) => void
  airlineHasError: boolean
  flightNumberHasError: boolean

  initialDate?: Date
}

const SearchFlight = (props: Props) => {
  const [selectedAirline, setAirline] = React.useState<server.dto.Airline>();
  const [flightNumber, setFlightNumber] = React.useState<string>("");
  const [departure, setDeparture] = React.useState<moment.Moment>(
    props.initialDate ? moment.utc(props.initialDate) : moment.utc().startOf("day")
  );
  const flightNumberInputRef = React.createRef<Input>();

  const onKeyPress = (event: KeyboardEvent) => {
    if (event.keyCode === 13) {
      props.onSearch(selectedAirline, flightNumber, departure);
    }
  };

  React.useEffect(() => {
    if (selectedAirline && flightNumberInputRef.current) {
      flightNumberInputRef.current.focus();
    }
  }, [selectedAirline]);

  React.useEffect(() => {
    document.addEventListener("keydown", onKeyPress, false);
    return () => {
      document.removeEventListener("keydown", onKeyPress, false);
    };
  }, [onKeyPress]); // it has to be reregistered every event or the callback will be stale

  return <>
    <div className="grow1" style={{ width: "30%" }}>
      <div className="padding">
        {selectedAirline &&
          <RemovableAirline
            airline={selectedAirline}
            onAirlineRemoved={() => { setAirline(undefined); }}
          />
        }
        {!selectedAirline &&
          <AirlinePaginatedDropdown
            value={selectedAirline}
            onChange={setAirline}
            config={{
              isSearchable: true,
              hasError: props.airlineHasError,
              focusOnMount: true
            }}
          />
        }
      </div>
    </div>

    <div style={{ textAlign: "right", paddingRight: 5 }} className="description grow1">
      {RESX.Flight.FlightNumber}:
    </div>
    <div className="grow1">
      <Input
        ref={flightNumberInputRef}
        type="text"
        value={flightNumber}
        error={props.flightNumberHasError && flightNumber.length === 0}
        onChange={(_, { value }) => { setFlightNumber(value); }}
        restrict={{
          allowDigits: true,
          allowLetters: false,
          allowUnderscore: false
        }}
        maxLength={4}
        placeholder="0000"
        style={{ width: 60 }} />
    </div>

    <div style={{ textAlign: "right", paddingRight: 5 }} className="description grow1">
      {RESX.Flight.Departure}:
    </div>
    <div className="grow1">
      <FilterDatePicker
        minDate={moment(serverReference.constants.appointment.minDate)}
        maxDate={moment(serverReference.constants.appointment.maxDate)}
        value={departure}
        onChange={setDeparture} />
    </div>

    <div>
      <button
        type="button"
        onClick={() => { props.onSearch(selectedAirline, flightNumber, departure); }}
        className="button-new tertiary">
        {RESX.GeneralLabels.Search}
      </button>
    </div>
  </>;
};

export default SearchFlight;
